import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiReviewUserContentRequestBody,
  IApiReviewUserContentResponseBody,
} from '../UserContentApi.types';
import { useApi } from '~/lib/api/useApi';
import { userGeneratedContentQueryKeyFactory } from './useUserContentQuery';

export type IUseReviewUserContentMutationValues = {
  appId: string;
  contentId: string;
  body: IApiReviewUserContentRequestBody;
};

export const useReviewUserContentMutation = (): UseMutationResult<
  IApiReviewUserContentResponseBody,
  unknown,
  IUseReviewUserContentMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseReviewUserContentMutationValues) =>
      api.userContent.review(values.appId, values.contentId, values.body),
    onSuccess: async (_, values) => {
      await queryClient.invalidateQueries({
        queryKey: userGeneratedContentQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
